<template>
    <div v-wechat-title="title" class="padding10" v-if="surgeryId && surgeryId > 0">
        <el-row type="flex" align="middle">
            <el-col class="align-right">
                <el-button type="primary" v-if="IsHavePermission(`use_drug_apply_create`) || IsHavePermission(`use_drug_apply_edit`)" size="mini" @click="saveInfo">保存</el-button>
                <el-button type="primary" v-if="IsHavePermission(`use_drug_apply_sync`)" size="mini" @click="syncItems">发送</el-button>
            </el-col>
        </el-row>
        <list-view
            :showSequence="false"
            ref="supplies-list"
            :datalist="datalist"
            :stripe="false"
            :tableHeight="tableHeight"
            @extrabutton-click="ExtraButtonClick"
            :columns="columnList"
            :buttons="[]">
        </list-view>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ApplyDrugs`,
    props: {},
    data() {
        return {
            title: `用药申请`,
            surgeryId: this.$route.query.surgery_id,
            applyInfo: null,
            token: this.$route.query.token,
            useDrugApplyktr: this.$root.carte_UseDrugApply || `0`,
            datalist: []
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `screenHeight`, `permissions`, `active_ward`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 180) || 0
        },
        columnList() {
            let me = this
            return [{
                type: `string`,
                prop: `___index`,
                label: `unique`,
                isKey: true
            }, {
                type: `string`,
                prop: `id`,
                label: `编号`
            }, {
                type: `remoteselect`,
                prop: `dic_drug`,
                label: `名称`,
                isListable: true,
                options: `/api/AcisSystem/Drug/SearchFullDrug`,
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                },
                change: (that, { row }) => {
                    if (row.dic_drug) {
                        let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                        req.then(data => {
                            if (data) {
                                this.$set(row, `spec`, data.spec)
                                this.$set(row, `apply_worker`, me.currentUser && {
                                    value: me.currentUser.dic_worker_id,
                                    label: me.currentUser.dic_worker_name
                                })
                                this.$set(row, `dic_drug_type_id`, data.drug_types && data.drug_types[0])
                            }

                            // 不新增行
                            if (row.addrow != undefined) {
                                row.addrow = `0`
                            } else {
                                row.addrow = `0`
                                if (me.IsHavePermission(`use_drug_apply_create`)) {
                                    this.datalist.push({ ___index: _.now(), active: true })
                                }
                            }
                        }).catch(e => { })
                    }
                }
            }, {
                type: `string`,
                prop: `spec`,
                label: `规格`,
                width: `180`,
                isListable: true,
                readonly: true
            }, {
                type: `select`,
                prop: `dic_drug_type_id`,
                label: `药品类型`,
                width: `150`,
                isListable: true,
                options: this[`drug/drug_type`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                }
            }, {
                type: `float`,
                prop: `amount`,
                label: `申请数量`,
                width: `150`,
                isListable: true,
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                }
            }, {
                type: `select`,
                prop: `unit`,
                label: `单位`,
                width: `120`,
                isListable: true,
                options: _.filter(this[`drug/drug_unit`], { isspeed: false }).map(d => {
                    return {
                        label: `${d.label}`,
                        value: d.value,
                        disabled: d.disabled
                    }
                }),
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                }
            }, {
                type: `remoteselect`,
                prop: `apply_worker`,
                label: `申请人`,
                width: `120`,
                isListable: true,
                options: `/api/AcisSystem/Worker/SearchForKey`,
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                }
            }, {
                type: `string`,
                prop: `remark`,
                label: `备注`,
                width: `180`,
                isListable: true,
                readonly: (that, { row }) => {
                    return !((me.IsHavePermission(`use_drug_apply_edit`) && row.id > 0) || (me.IsHavePermission(`use_drug_apply_create`) && !row.id)) || row.apply_status == 1
                }
            }, {
                type: `string`,
                prop: `send_status`,
                label: `状态`,
                width: `100`,
                isListable: true,
                readonly: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `120`,
                isListable: me.IsHavePermission(`use_drug_apply_delete`),
                fixed: `right`,
                readonly: false,
                options: (that, { row }) => {
                    if (row.dic_drug && row.apply_status != 1) {
                        return [
                            {
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `removeItem`,
                                permission: `default`
                            }
                        ]
                    }
                }
            }]
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    mounted() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        //  加载所有枚举
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadItems()
    },
    methods: {
        loadItems() {
            return new Promise((resolve, reject) => {
                var that = this
                that.applyInfo = null
                that.datalist = []
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                let req = this.myaxios.get(`/api/AcisSystem/UseDrugApply/GetBySurgeryId?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    if (data) {
                        that.applyInfo = data
                        that.datalist = _.map(data.details, (d, index) => {
                            d.___index = _.now() + (index + 1) * 1000
                            d.dic_drug = {
                                label: (d.drug && d.drug.full_name) || ``,
                                value: (d.drug && d.drug.id) || 0,
                                code: (d.drug && d.drug.code) || 0,
                                abbr: (d.drug && d.drug.abbr) || 0
                            }
                            d.spec = (d.drug && d.drug.spec) || ``
                            d.addrow = `0`
                            return d
                        })
                    } else {
                        that.applyInfo = null
                    }
                    if (that.IsHavePermission(`use_drug_apply_create`)) {
                        that.datalist.push({ active: true })
                    }
                    resolve()
                }).catch(e => reject(e))
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        removeItem({ row, index }) {
            if (row.id > 0) {
                let req = this.myaxios.delete(`/api/AcisSystem/UseDrugApplyDetail/Delete/${row.id}`)
                req.then(data => {
                    this.datalist.splice(index, 1)
                })
            } else {
                this.datalist.splice(index, 1)
            }
        },
        getAdd(savedata) {
            var that = this
            let data1 = _.map(
                _.filter(savedata, d => !d.id),
                d => {
                    return {
                        id: d.id,
                        apply_status: 0,
                        apply_worker_id: d.apply_worker_id,
                        biz_use_drug_apply_Id: that.applyInfo.id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        amount: d.amount,
                        unit: d.unit,
                        remark: d.remark
                    }
                }
            )
            return data1
        },
        getEdit(savedata) {
            var that = this
            let data2 = _.map(
                _.filter(savedata, d => d.id > 0),
                d => {
                    return {
                        id: d.id,
                        apply_status: 0,
                        apply_worker_id: d.apply_worker_id,
                        biz_use_drug_apply_Id: that.applyInfo.id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        amount: d.amount,
                        unit: d.unit,
                        remark: d.remark
                    }
                }
            )
            return data2
        },
        getApply() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!that.surgeryId || that.surgeryId == 0) {
                    resolve()
                } else {
                    let inputModel = {
                        biz_surgery_info_id: that.surgeryId,
                        apply_type: 1
                    }
                    let req = this.myaxios.post(`/api/AcisSystem/UseDrugApply/Post`, inputModel)
                    req.then(data => {
                        that.applyInfo = data
                        resolve(data)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        saveItems(type) {
            let that = this
            return new Promise((resolve, reject) => {
                var nonePayTypeArr = []
                var savedata = _.filter(that.datalist, d => d.dic_drug && d.dic_drug != null)
                savedata.forEach(d => {
                    d.apply_worker_id = d.apply_worker.value
                    if (!d.dic_drug || !d.amount || !d.dic_drug_type_id || !d.unit) {
                        nonePayTypeArr.push(d)
                        this.$set(d, `class_name`, `fontred`)
                    } else {
                        this.$set(d, `class_name`, ``)
                    }
                })
                if (nonePayTypeArr.length > 0) {
                    this.$message.error(`药品、申请数量、药品类型、单位不能为空！`)
                    return
                }
                let data1 = this.getAdd(savedata)
                let data2 = this.getEdit(savedata)
                if (data1.length > 0 || data2.length > 0) {
                    let req1 = this.myaxios.post(`/api/AcisSystem/UseDrugApplyDetail/PostMany`, data1)
                    let req2 = this.myaxios.put(`/api/AcisSystem/UseDrugApplyDetail/PutMany`, data2)
                    this.myaxios
                        .all(req1, req2)
                        .then(res => {
                            this.loadItems()
                            if (type == 1) {
                                this.$message.success(`保存成功`)
                            }
                            resolve()
                        })
                        .catch(e => reject(e))
                } else {
                    if (type == 1) {
                        this.$message.warning(`没有可保存项`)
                    }
                    resolve()
                }
            })
        },
        saveInfo() {
            let that = this
            if (!that.applyInfo) {
                that.getApply().then(() => {
                    that.saveItems(1)
                })
            } else {
                that.saveItems(1)
            }
        },
        syncItems() {
            let that = this
            if (!that.applyInfo) {
                that.getApply().then(() => {
                    that.saveItems(2).then(() => {
                        that.syncInfo()
                    })
                })
            } else {
                that.saveItems(2).then(() => {
                    that.syncInfo()
                })
            }
        },
        syncInfo() {
            let that = this
            console.log(`${that.currentUser.dic_worker_id}|${that.surgeryId}`)
            if (that.useDrugApplyktr && that.useDrugApplyktr != `0`) {
                let str = `p=${that.currentUser.dic_worker_id}|${that.surgeryId}`
                let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_UseDrugApply&paramStr=${str}`)
                req.then(data => {
                    this.loadItems()
                }).catch(e => {
                    console.log(e)
                })
            } else {
                this.$message.warning(`未配置carte文件，请确认！`)
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadItems()
        }
    }
}
</script>
<style scoped lang="less">
/deep/.bg-write {
    background: white;
    cursor: pointer;
}
.config-column {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}

.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/UseDrugApply/Index.vue